import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.scss'],
    standalone: false
})
export class SigninComponent {    
  loginGovUrl: string = '';
  showError:boolean = false;
  showNoAccountError:boolean = false;
  showLoginGovError:boolean = false;
  fromDriver:boolean = false;
  username:string = "";  
  messageId: any = null;

  @ViewChild('LoginGovErrorModal') loginGovErrorModal: TemplateRef<any> | undefined;

  constructor(private generalService: GeneralService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public authService: AuthenticationService,
    public modalService: NgbModal) {

  }
     
     ngOnInit() {
          setTimeout(() => this.scrollToTop(), 500);
     }

  ngAfterViewInit(): void {
      window.onbeforeunload = null;

      this.activatedRoute.queryParams.subscribe(params => {
        this.messageId = params['message'] || null; 
        const as = params['as'];

        let ngbModalOptions: NgbModalOptions = {
          backdrop : 'static',
          keyboard : false,
          ariaLabelledBy: (this.messageId == 3) ? 'noAccountErrorModalTitle' : 'loginGovErrorModalTitle',
        };
        
        if (this.messageId) {
            switch (this.messageId) {
            case "1":
              this.showError = true;
              this.username = this.authService.getUserName();
              break;
            case "2":
              this.showLoginGovError = true;
              this.showNoAccountError = false;
              this.modalService.open(this.loginGovErrorModal, ngbModalOptions);
              break;
            }
        }
        if (as && as === "driver") {
             this.fromDriver = true;
        }

      }
   );
  }

  get shouldLogout() {
    return this.messageId !== null;
  }

  async redirectToLoginGov() {
    if (this.messageId !== null) {
      this.logoff();
    }
      /* check for IAH deep link. If so pass to login.gov link for state persistence. */
      let authCode = '';
      const deepLink = this.authService.getDeepLink();
      if (deepLink) {
          if(deepLink.indexOf('byAuthCode') >0){
              const parts = deepLink.split('/');
              authCode = parts[parts.length-1];
          }
      }
       
      this.generalService.getLoginGovUrl(authCode).subscribe((response : any) => {
          this.loginGovUrl = response;
          window.location.href = this.loginGovUrl;
      });
  }

  //this is just for local forcing a log off. sometimes it seem to have a hard to getting login.gov to to it.
  // get ShowFroceLogoff() {
  //   if (environment.NODE_ENV === '') {
  //     return true;
  //   }
  //   return false;
  // }

  logoff() {
      this.authService.logout();
  }
  
  hideLoginGovInfoModal() {
      this.showNoAccountError = false;
  }

  scrollToTop() {
      window.scrollTo(0, 0);
  }

  setId(){
      return true;
  }
}
